import React from "react";

import "../ScroolDown/ScrollDown.scss"

export default function ScrollDown() {
  return (
    <div className="container">
      <a href="#about-me">
        <div class="chevron"></div>
        <div class="chevron"></div>
        <div class="chevron"></div>
      </a>
    </div>
  );
}
